import {
  FETCH_DRS_EBT_LOGS_REQUEST,
  FETCH_DRS_EBT_LOGS_SUCCESS,
  FETCH_DRS_EBT_LOGS_FAILURE
} from "../actions/ebt_logs";

import {
  FETCH_RETAIL_EBT_LOGS_REQUEST,
  FETCH_RETAIL_EBT_LOGS_SUCCESS,
  FETCH_RETAIL_EBT_LOGS_FAILURE
} from "../actions/ebt_retail_logs";

const initialState = {
  ebt_drs_logs: [],
  total_ebt_drs_logs: 0,
  ebt_retail_logs: [],
  total_ebt_retail_logs: 0,
  loading: false,
  error: null
};

const ebtLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DRS_EBT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_RETAIL_EBT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DRS_EBT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        ebt_drs_logs: action.payload.data,
        total_ebt_drs_logs: action.payload.total
      };
    case FETCH_RETAIL_EBT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        ebt_retail_logs: action.payload.data,
        total_ebt_retail_logs: action.payload.total
      };
    case FETCH_DRS_EBT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_RETAIL_EBT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default ebtLogsReducer;